import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { GuidePage } from "./guides.$slug";
import { getPost } from "../lib/api/lidoo.functions";
import { LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { hreflangLinks } from "../lib/seo";

export const Route = createFileRoute("/$locale/guides/$slug")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/guides/$slug", params: { slug: params.slug } });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  loader: async ({ params }) => {
    // getPost falls back to the English row when a translation is missing, so a
    // guide is never a dead link in a language we have not written it in yet.
    const res = await getPost({ data: { slug: params.slug, lang: params.locale as Lang } });
    if (!res.post) throw notFound();
    return res;
  },
  head: (ctx) => {
    const post = ctx.loaderData?.post;
    return {
      meta: [
        { title: post ? `${post.title} | sunbedly` : "Guide | sunbedly" },
        { name: "description", content: post?.excerpt ?? "" },
        ...(post ? [{ property: "og:type", content: "article" }] : []),
      ],
      links: hreflangLinks(`/guides/${ctx.params.slug}`, ctx.params.locale),
    };
  },
  component: () => {
    const { post, clubs } = Route.useLoaderData();
    return <GuidePage post={post} clubs={clubs} />;
  },
});
